import { useAuth } from '../../../contexts/AuthContext'
import useProductCategories from '../../../hooks/useProductCategories'
import USER_TYPE from '../../../constants/userType'
import { useNavigate } from 'react-router-dom'

const RequestListItem = ({ request }) => {
  const navigate = useNavigate()
  const { getCategoryNameById } = useProductCategories()
  const { currentUser } = useAuth()
  const isBid = !!request.productId

  const isExpired = () => {
    if (!request?.expiresAt) return false

    const expiryTimestamp = new Date(request?.expiresAt).getTime()
    return expiryTimestamp < Date.now()
  }

  const renderIsNew = () => {
    if (isExpired()) {
      return <></>
    }

    if (!request.canBid) {
      return
    }

    return (
      <div className="flex gap-2 items-center">
        <span className="h-[10px] w-[10px] rounded-full bg-success"></span>
        <span className="text-success-500 text-xs">New</span>
      </div>
    )
  }

  const renderActionButton = () => {
    if (currentUser?.userType !== USER_TYPE.retailer) {
      return <></>
    }

    return (
      <button
        className="text-md text-secondary-600 underline"
        onClick={() => {
          navigate(`/retailer/products/requests/${request.id}`)
        }}
      >
        View
      </button>
    )
  }

  return (
    <>
      <div className="flex items-center p-3 bg-background border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200">
        <img
          src={request.imageUrl || '/images/default-product.png'}
          alt={request.productName || 'Product Image'}
          className="w-16 h-16 object-cover rounded-md mr-4"
        />
        <div className="flex-1 flex items-center justify-between">
          <div>
            <h3 className="text-md font-semibold text-gray-800 line-clamp-1">
              {isBid ? request.productName : getCategoryNameById(request.categoryId)}
            </h3>
            <p className="text-sm text-gray-500">{isBid ? 'Product bidding' : 'Product finder'}</p>
            {renderIsNew()}
          </div>
          <div>{renderActionButton()}</div>
        </div>
      </div>
    </>
  )
}

export default RequestListItem
